(function () {
  function init() {
    if (window.location.pathname === '/products' || window.location.pathname === '/products/') {
      window.location.replace('/collections/all');
      return;
    }
    var menuButton = document.querySelector('.mobile-menu-toggle');
    var drawer = document.getElementById('mobileMenuDrawer');
    var closeButton = document.querySelector('.mobile-menu-close');

    function setHidden(el, hidden) {
      if (!el) return;
      el.hidden = hidden;
      el.classList.toggle('is-open', !hidden);
    }

    if (menuButton && drawer) {
      menuButton.addEventListener('click', function () {
        var open = drawer.hidden;
        setHidden(drawer, !open);
        menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (closeButton && drawer) {
      closeButton.addEventListener('click', function () {
        setHidden(drawer, true);
        if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
      });
    }

    function syncFooterAccordions() {
      var desktop = window.innerWidth > 900;
      document.querySelectorAll('.footer-accordion').forEach(function (details) {
        details.open = desktop;
      });
    }
    syncFooterAccordions();
    window.addEventListener('resize', syncFooterAccordions);



    var sortForm = document.querySelector('[data-preserve-query-sort]');
    if (sortForm) {
      sortForm.addEventListener('submit', function(event){
        event.preventDefault();
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortForm.querySelector('[name="sort_by"]').value);
        window.location.assign(url.toString());
      });
    }

    // Classic collection filters: no dependency on Shopify Search & Discovery.
    // Shopify's native storefront filter query parameters do the server-side filtering.
    var classicFilterForm = document.querySelector('.premium-filter-form[data-classic-filters]');
    if (classicFilterForm) {
      var classicUrl = new URL(window.location.href);
      var classicNames = ['filter.v.price.gte','filter.v.price.lte','filter.v.availability','filter.p.vendor'];
      classicNames.forEach(function (name) {
        var values = classicUrl.searchParams.getAll(name);
        classicFilterForm.querySelectorAll('input[name="' + name + '"],select[name="' + name + '"]').forEach(function (input) {
          if (input.type === 'checkbox') input.checked = values.indexOf(input.value) !== -1;
          else if (values.length) input.value = values[0];
        });
      });
      classicFilterForm.addEventListener('submit', function () {
        // Category/type is handled independently of Shopify Search & Discovery.
        // Send the visitor to Shopify's native product search using the product_type
        // search operator, so the selected category actually changes the products.
        var category = classicFilterForm.querySelector('[data-category-filter]:checked');
        if (category) {
          event.preventDefault();
          var searchUrl = new URL(window.location.origin + '/search');
          searchUrl.searchParams.set('q', 'product_type:' + category.value);
          searchUrl.searchParams.set('type', 'product');
          window.location.assign(searchUrl.toString());
          return;
        }
        // Empty numeric fields must not create empty query parameters.
        classicFilterForm.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (!input.value.trim()) input.disabled = true;
        });
      });
    }

    // Mobile premium filter drawer
    var filterToggle = document.querySelector('.filter-mobile-toggle');
    var filterSidebar = document.getElementById('collectionFilters');
    var filterClose = document.querySelector('.filter-mobile-close');
    function setFilters(open) {
      if (!filterSidebar) return;
      filterSidebar.classList.toggle('is-open', open);
      if (filterToggle) filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('filter-drawer-open', open);
    }
    if (filterToggle) filterToggle.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); setFilters(true); });
    if (filterClose) filterClose.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); setFilters(false); });

    if (filterSidebar) filterSidebar.addEventListener('click', function (event) { event.stopPropagation(); });
    document.addEventListener('click', function (event) {
      if (document.body.classList.contains('filter-drawer-open') && filterSidebar && !filterSidebar.contains(event.target) && event.target !== filterToggle) setFilters(false);
    });

    // Pull-to-refresh on touch devices, only when the page is already at the top.
    var pullStart = 0, pullDistance = 0, pulling = false, refreshing = false;
    var pullIndicator = null;
    function ensurePullIndicator() {
      if (pullIndicator) return;
      pullIndicator = document.createElement('div');
      pullIndicator.className = 'mobile-pull-refresh';
      pullIndicator.innerHTML = '<span>↓</span><small>Trage pentru reîmprospătare</small>';
      document.body.appendChild(pullIndicator);
    }
    if (window.matchMedia('(pointer:coarse)').matches) {
      ensurePullIndicator();
      document.addEventListener('touchstart', function (e) {
        if (window.scrollY <= 0 && e.touches.length === 1 && !document.body.classList.contains('filter-drawer-open')) {
          pullStart = e.touches[0].clientY; pullDistance = 0; pulling = true;
        } else pulling = false;
      }, {passive:true});
      document.addEventListener('touchmove', function (e) {
        if (!pulling || refreshing) return;
        pullDistance = Math.max(0, e.touches[0].clientY - pullStart);
        if (pullIndicator && pullDistance > 8) {
          var progress = Math.min(1, pullDistance / 92);
          pullIndicator.style.transform = 'translateY(' + Math.min(46, pullDistance * .5) + 'px)';
          pullIndicator.classList.toggle('ready', progress >= 1);
          pullIndicator.querySelector('small').textContent = progress >= 1 ? 'Eliberează pentru refresh' : 'Trage pentru reîmprospătare';
        }
      }, {passive:true});
      document.addEventListener('touchend', function () {
        if (!pulling) return;
        pulling = false;
        if (pullDistance >= 92 && !refreshing) {
          refreshing = true;
          if (pullIndicator) { pullIndicator.classList.add('refreshing'); pullIndicator.querySelector('small').textContent = 'Se reîmprospătează…'; }
          window.location.reload();
        } else if (pullIndicator) {
          pullIndicator.style.transform = ''; pullIndicator.classList.remove('ready');
        }
      }, {passive:true});
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setFilters(false);
        setHidden(drawer, true);
        if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Premium product gallery: thumbnails + previous/next arrows + keyboard support.
  var gallery = document.querySelector('[data-product-gallery]');
  var thumbs = document.querySelectorAll('.product-media-thumb');
  var mainImage = document.querySelector('.premium-product-image img');
  if (gallery && mainImage && thumbs.length) {
    var currentIndex = 0;
    var counter = gallery.querySelector('[data-gallery-current]');

    function showProductImage(index) {
      if (!thumbs.length) return;
      currentIndex = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[currentIndex];
      var image = thumb.querySelector('img');
      if (!image) return;
      var fullSrc = thumb.getAttribute('href') || image.currentSrc || image.src;
      mainImage.src = fullSrc;
      mainImage.removeAttribute('srcset');
      thumbs.forEach(function (item) { item.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (counter) counter.textContent = String(currentIndex + 1);
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        showProductImage(index);
      });
    });

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { showProductImage(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { showProductImage(currentIndex + 1); });

    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') showProductImage(currentIndex - 1);
      if (event.key === 'ArrowRight') showProductImage(currentIndex + 1);
    });
    gallery.setAttribute('tabindex', '0');
  }

  // Product image zoom lightbox
  var zoomOpen = document.querySelector('[data-product-zoom-open]');
  var zoomOverlay = document.getElementById('productZoomOverlay');
  var zoomImage = document.querySelector('[data-product-zoom-image]');
  var zoomClose = document.querySelector('[data-product-zoom-close]');
  function closeProductZoom(){
    if (!zoomOverlay) return;
    zoomOverlay.hidden = true;
    document.body.classList.remove('modal-open');
  }
  if (zoomOpen && zoomOverlay && zoomImage && mainImage) {
    zoomOpen.addEventListener('click', function(){
      zoomImage.src = mainImage.currentSrc || mainImage.src;
      zoomImage.alt = mainImage.alt || '';
      zoomOverlay.hidden = false;
      document.body.classList.add('modal-open');
    });
    if (zoomClose) zoomClose.addEventListener('click', closeProductZoom);
    zoomOverlay.addEventListener('click', function(e){ if (e.target === zoomOverlay) closeProductZoom(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeProductZoom(); });
  }

  // Product description: detectează specificații chiar și când sunt puse în aceeași linie,
  // separate prin virgulă / ; / | / <br>. Exemplu: "Diametru fir: 0,30 mm, Rezistență: 12 lb".
  var description = document.querySelector('.product-description');
  if (description && !description.querySelector('.product-spec-list')) {
    var escapeHtml = function(value){
      return String(value || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    };
    var specs = [], seen = {};
    var label = '[A-Za-zĂÂÎȘŞȚŢăâîșşțţ0-9][^:,\n]{1,48}';
    var re = new RegExp('('+label+')\\s*:\\s*(.*?)(?=(?:,|;|\\||\\n)\\s*'+label+'\\s*:|$)','g');
    var textNodes = [], walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT, null);
    var node;
    while(node = walker.nextNode()) { if(node.nodeValue && node.nodeValue.trim()) textNodes.push(node); }
    textNodes.forEach(function(n){
      var text = n.nodeValue.replace(/\s+/g,' ').trim();
      re.lastIndex = 0;
      var matches = [], m;
      while((m = re.exec(text))){
        var l=m[1].trim(), v=m[2].trim().replace(/[,;|]+$/,'').trim();
        if(l && v && v.length <= 180){
          var key=(l+'|'+v).toLowerCase();
          if(!seen[key]){ seen[key]=true; specs.push({label:l,value:v}); }
          matches.push({label:l,value:v});
        }
      }
      // Dacă nodul conține doar specificații, îl golim; restul textului rămâne vizibil.
      if(matches.length){
        var remaining=text;
        matches.forEach(function(x){
          var safe=x.label.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
          var part=new RegExp(safe+'\\s*:\\s*[^,;|\\n]+(?=(?:,|;|\\||\\n)\\s*'+label+'\\s*:|$)','i');
          remaining=remaining.replace(part,'');
        });
        n.nodeValue=remaining.replace(/^[,;|\s]+|[,;|\s]+$/g,'').replace(/\s{2,}/g,' ');
      }
    });
    if(specs.length >= 2){
      var box=document.createElement('div');
      box.className='product-spec-list'; box.setAttribute('role','table'); box.setAttribute('aria-label','Specificații produs');
      box.innerHTML=specs.map(function(x){ return '<div class="product-spec-row" role="row"><span role="cell">'+escapeHtml(x.label)+'</span><strong role="cell">'+escapeHtml(x.value)+'</strong></div>'; }).join('');
      description.insertBefore(box, description.firstChild);
    }
  }


})();


(function(){
  var trigger=document.querySelector('.accessibility-trigger'), panel=document.getElementById('accessibilityPanel');
  if(!trigger||!panel) return;
  var keys=['text-large','high-contrast','grayscale','underline','motion','focus'];
  function apply(key,on){ document.documentElement.classList.toggle('a11y-'+key,on); try{localStorage.setItem('carponiq-'+key,on?'1':'0')}catch(e){} }
  keys.forEach(function(k){try{if(localStorage.getItem('carponiq-'+k)==='1') apply(k,true)}catch(e){}});
  trigger.addEventListener('click',function(){var open=panel.hidden; panel.hidden=!open; trigger.setAttribute('aria-expanded',open?'true':'false'); if(open){var first=panel.querySelector('button'); if(first) first.focus();}});
  panel.addEventListener('click',function(e){var b=e.target.closest('button[data-a11y]'); if(!b)return; var k=b.getAttribute('data-a11y'); if(k==='reset'){keys.forEach(function(x){apply(x,false)});return} apply(k,!document.documentElement.classList.contains('a11y-'+k));});
  var close=panel.querySelector('.accessibility-close'); if(close) close.addEventListener('click',function(){panel.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.focus()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!panel.hidden){panel.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.focus()}});
})();


(function(){
  'use strict';

  var STORAGE_COMPARE = 'carponiq-compare-v1';
  var STORAGE_FAVORITES = 'carponiq-favorites-v1';
  var MAX_COMPARE = 4;
  var STORAGE_EXTERNAL = 'carponiq-compare-external-v1';

  function read(key) {
    try {
      var value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) { return []; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function readExternalOffers() { return read(STORAGE_EXTERNAL); }
  function getExternalOffer(id) {
    var list = readExternalOffers();
    return list.find(function(x){ return String(x.id) === String(id); }) || { id: id, url: '', price: '', site: '' };
  }
  function saveExternalOffer(id, data) {
    var list = readExternalOffers().filter(function(x){ return String(x.id) !== String(id); });
    if (data.url || data.price || data.site || data.image || data.title || data.brand || data.description) list.push({ id: String(id), url: data.url || '', price: data.price || '', site: data.site || '', image: data.image || '', title: data.title || '', brand: data.brand || '', description: data.description || '' });
    write(STORAGE_EXTERNAL, list);
  }
  function cleanExternalUrl(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';
    if (!/^https?:\/\//i.test(raw)) raw = 'https://' + raw;
    try {
      var u = new URL(raw);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return '';
      return u.href;
    } catch(e) { return ''; }
  }
  function siteFromUrl(value) {
    try { return new URL(value).hostname.replace(/^www\./,''); } catch(e) { return ''; }
  }
  function normalizeExternalPrice(value, currency) {
    if (value === null || value === undefined || value === '') return '';
    var n = Number(String(value).replace(/[^0-9.,-]/g, '').replace(/,(?=\d{3}(?:\D|$))/g, '').replace(',', '.'));
    if (!isFinite(n)) return String(value).trim();
    var cur = currency || '';
    return n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (cur ? ' ' + cur : '');
  }
  function extractExternalPrice(html) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var scripts = Array.prototype.slice.call(doc.querySelectorAll('script[type=\"application/ld+json\"]'));
      var found = '';
      scripts.some(function(script){
        try {
          var data = JSON.parse(script.textContent);
          var nodes = Array.isArray(data) ? data : (data && Array.isArray(data['@graph']) ? data['@graph'] : [data]);
          return nodes.some(function(node){
            if (!node) return false;
            var offers = node.offers || node.offer;
            if (Array.isArray(offers)) offers = offers[0];
            if (offers && offers.price !== undefined) { found = normalizeExternalPrice(offers.price, offers.priceCurrency); return !!found; }
            if (node.price !== undefined) { found = normalizeExternalPrice(node.price, node.priceCurrency); return !!found; }
            return false;
          });
        } catch(e) { return false; }
      });
      if (found) return found;
      var meta = doc.querySelector('meta[itemprop=price], meta[property=\"product:price:amount\"], meta[name=\"price\"]');
      if (meta && meta.content) {
        var currencyMeta = doc.querySelector('meta[itemprop=priceCurrency], meta[property=\"product:price:currency\"], meta[name=\"currency\"]');
        return normalizeExternalPrice(meta.content, currencyMeta && currencyMeta.content);
      }
      var priceEl = doc.querySelector('[itemprop=price], [data-product-price], [data-price]');
      if (priceEl) {
        var raw = priceEl.getAttribute('content') || priceEl.getAttribute('data-price') || priceEl.textContent;
        var currencyEl = doc.querySelector('[itemprop=priceCurrency], [data-currency]');
        return normalizeExternalPrice(raw, currencyEl && (currencyEl.getAttribute('content') || currencyEl.getAttribute('data-currency') || currencyEl.textContent));
      }
    } catch(e) {}
    return '';
  }
  function extractExternalDetails(html, url) {
    var out = {price:'', image:'', title:'', brand:'', description:'', site: siteFromUrl(url)};
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var scripts = Array.prototype.slice.call(doc.querySelectorAll('script[type="application/ld+json"]'));
      scripts.some(function(script){
        try {
          var data = JSON.parse(script.textContent);
          var nodes = Array.isArray(data) ? data : (data && Array.isArray(data['@graph']) ? data['@graph'] : [data]);
          return nodes.some(function(node){
            if(!node || (node['@type'] && String(node['@type']).toLowerCase().indexOf('product')<0)) return false;
            out.title = out.title || node.name || '';
            out.description = out.description || node.description || '';
            out.brand = out.brand || (node.brand && (node.brand.name || node.brand)) || '';
            var im = node.image; if(Array.isArray(im)) im=im[0];
            out.image = out.image || im || '';
            var offers=node.offers||node.offer; if(Array.isArray(offers)) offers=offers[0];
            if(offers && offers.price!=null) out.price=normalizeExternalPrice(offers.price,offers.priceCurrency);
            return !!(out.price && out.image);
          });
        } catch(e) { return false; }
      });
      function meta(sel){var e=doc.querySelector(sel);return e&&e.content?e.content.trim():'';}
      out.image = out.image || meta('meta[property="og:image"]') || meta('meta[name="twitter:image"]');
      out.title = out.title || meta('meta[property="og:title"]') || (doc.querySelector('h1')||{}).textContent || doc.title || '';
      out.description = out.description || meta('meta[property="og:description"]') || meta('meta[name="description"]');
      out.brand = out.brand || meta('meta[itemprop="brand"]');
      if(!out.price) out.price=extractExternalPrice(html);
      if(out.image){try{out.image=new URL(out.image,url).href}catch(e){}}
    }catch(e){}
    return out;
  }
  function fetchExternalDetails(url) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function(){ controller.abort(); }, 12000) : null;
    return fetch(url,{mode:'cors',credentials:'omit',signal:controller?controller.signal:undefined,headers:{'Accept':'text/html,application/xhtml+xml'}})
      .then(function(r){if(!r.ok)throw new Error('HTTP '+r.status);return r.text();})
      .then(function(html){return extractExternalDetails(html,url);})
      .finally(function(){if(timer)clearTimeout(timer);});
  }
  function fetchExternalDetailsViaReader(url) {
    var readerUrl='https://r.jina.ai/http://'+url.replace(/^https?:\/\//i,'');
    return fetch(readerUrl,{mode:'cors',credentials:'omit'})
      .then(function(r){if(!r.ok)throw new Error('READER_'+r.status);return r.text();})
      .then(function(text){
        var out={price:'',image:'',title:'',brand:'',description:'',site:siteFromUrl(url)};
        var lines=text.split(/\n+/).map(function(x){return x.trim();}).filter(Boolean);
        out.title=(lines.find(function(x){return /^#\s+/.test(x);})||'').replace(/^#+\s*/,'');
        var img=text.match(/!\[[^\]]*\]\((https?:\/\/[^)]+)\)/i); if(img) out.image=img[1];
        var pm=[/(?:\bEUR|€|RON|lei)\s*([0-9][0-9.,]*)/i,/([0-9][0-9.,]*)\s*(?:EUR|€|RON|lei)\b/i,/(?:price|pret|preț)[^0-9]{0,50}([0-9][0-9.,]*)/i];
        for(var i=0;i<pm.length;i++){var m=text.match(pm[i]);if(m){out.price=normalizeExternalPrice(m[1],/EUR|€/i.test(m[0])?'EUR':'lei');break;}}
        out.description=(lines.slice(1,8).join(' ').slice(0,500));
        return out;
      });
  }
  function fetchExternalPrice(url) {
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function(){ controller.abort(); }, 10000) : null;
    return fetch(url, { mode: 'cors', credentials: 'omit', signal: controller ? controller.signal : undefined, headers: { 'Accept': 'text/html,application/xhtml+xml' } })
      .then(function(r){ if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(extractExternalPrice)
      .then(function(price){ if (!price) throw new Error('PRICE_NOT_FOUND'); return price; })
      .finally(function(){ if (timer) clearTimeout(timer); });
  }
  function fetchExternalPriceViaReader(url) {
    var readerUrl = 'https://r.jina.ai/http://' + url.replace(/^https?:\/\//i, '');
    return fetch(readerUrl, { mode: 'cors', credentials: 'omit' })
      .then(function(r){ if (!r.ok) throw new Error('READER_' + r.status); return r.text(); })
      .then(function(text){
        var patterns = [/(?:\bEUR|€|RON|lei|RON\s*)\s*([0-9][0-9.,]*)/i, /([0-9][0-9.,]*)\s*(?:EUR|€|RON|lei)\b/i, /(?:price|pret|preț)[^0-9]{0,40}([0-9][0-9.,]*)/i];
        for (var i=0;i<patterns.length;i++){ var m=text.match(patterns[i]); if(m) return normalizeExternalPrice(m[1], /EUR|€/i.test(m[0]) ? 'EUR' : 'lei'); }
        throw new Error('PRICE_NOT_FOUND');
      });
  }
  function lookupExternalDetails(url) {
    return fetchExternalDetails(url).catch(function(){ return fetchExternalDetailsViaReader(url); });
  }
  function productFromCard(card) {
    if (!card) return null;
    return {
      id: card.dataset.productId,
      title: card.dataset.title || '',
      vendor: card.dataset.vendor || '—',
      type: card.dataset.type || '—',
      price: card.dataset.price || '0',
      priceFormatted: card.dataset.priceFormatted || '',
      available: card.dataset.available === 'true',
      url: card.dataset.url || '#',
      image: card.dataset.image || '',
      tags: card.dataset.tags || '',
      variants: card.dataset.variants || '1'
    };
  }
  function findCard(id) {
    return document.querySelector('[data-product-card][data-product-id="' + CSS.escape(String(id)) + '"]');
  }
  function syncButtons() {
    var compares = read(STORAGE_COMPARE);
    var favorites = read(STORAGE_FAVORITES);
    document.querySelectorAll('[data-product-card][data-product-id]').forEach(function(card){
      var id = String(card.dataset.productId);
      var fav = favorites.some(function(p){ return String(p.id) === id; });
      var cmp = compares.some(function(p){ return String(p.id) === id; });
      card.querySelectorAll('[data-product-action="favorite"]').forEach(function(btn){
        btn.classList.toggle('is-active', fav);
        btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
        btn.innerHTML = fav ? '♥' + (btn.querySelector('span') ? ' <span>Elimină de la favorite</span>' : '') : '♡' + (btn.querySelector('span') ? ' <span>Adaugă la favorite</span>' : '');
      });
      card.querySelectorAll('[data-product-action="compare"]').forEach(function(btn){
        btn.classList.toggle('is-active', cmp);
        btn.setAttribute('aria-pressed', cmp ? 'true' : 'false');
        if (btn.querySelector('span')) btn.innerHTML = (cmp ? '✓' : '⇄') + ' <span>' + (cmp ? 'În comparare' : 'Adaugă la comparare') + '</span>';
        else btn.textContent = cmp ? '✓' : '⇄';
      });
    });
    document.querySelectorAll('[data-favorite-count]').forEach(function(el){ el.textContent = favorites.length; el.hidden = favorites.length === 0; });
    document.querySelectorAll('[data-compare-count]').forEach(function(el){ el.textContent = compares.length; el.hidden = compares.length === 0; });
  }
  function notify(message) {
    var note = document.querySelector('.carponiq-toast');
    if (!note) {
      note = document.createElement('div');
      note.className = 'carponiq-toast';
      document.body.appendChild(note);
    }
    note.textContent = message;
    note.classList.add('is-visible');
    clearTimeout(note._timer);
    note._timer = setTimeout(function(){ note.classList.remove('is-visible'); }, 2200);
  }
  function toggleFavorite(card) {
    var p = productFromCard(card), list = read(STORAGE_FAVORITES);
    var index = list.findIndex(function(x){ return String(x.id) === String(p.id); });
    if (index >= 0) { list.splice(index, 1); notify('Produs eliminat din favorite.'); }
    else { list.unshift(p); notify('Produs adăugat la favorite.'); }
    write(STORAGE_FAVORITES, list);
    syncButtons();
    renderFavorites();
  }
  function toggleCompare(card) {
    var p = productFromCard(card), list = read(STORAGE_COMPARE);
    var index = list.findIndex(function(x){ return String(x.id) === String(p.id); });
    if (index >= 0) {
      list.splice(index, 1);
      notify('Produs eliminat din comparare.');
    } else {
      if (list.length >= MAX_COMPARE) { notify('Poți compara maximum 4 produse.'); openCompare(); return; }
      list.push(p);
      notify('Produs adăugat la comparare.');
    }
    write(STORAGE_COMPARE, list);
    syncButtons();
    renderCompare();
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function openCompare() {
    var el = document.getElementById('compareOverlay');
    if (el) { el.hidden = false; document.body.classList.add('modal-open'); renderCompare(); }
  }
  function closeCompare() {
    var el = document.getElementById('compareOverlay');
    if (el) { el.hidden = true; document.body.classList.remove('modal-open'); }
  }
  function renderCompare() {
    var wrap = document.querySelector('[data-compare-content]'), empty = document.querySelector('[data-compare-empty]');
    if (!wrap || !empty) return;
    var list = read(STORAGE_COMPARE);
    empty.hidden = list.length > 0;
    wrap.innerHTML = '';
    if (!list.length) return;
    var table = document.createElement('div');
    table.className = 'compare-table-wrap';
    var html = '<table class="compare-table"><thead><tr><th>Caracteristică</th>';
    list.forEach(function(p){
      html += '<th><div class="compare-product-head">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '">' : '') +
        '<a href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<button type="button" data-remove-compare="' + esc(p.id) + '">Elimină</button></div></th>';
    });
    html += '</tr></thead><tbody>';
    var rows = [
      ['Preț', function(p){ return '<strong>' + esc(p.priceFormatted) + '</strong>'; }],
      ['Marcă / brand', function(p){ return esc(p.vendor); }],
      ['Tip produs', function(p){ return esc(p.type); }],
      ['Disponibilitate', function(p){ return p.available ? '<span class="compare-ok">Disponibil</span>' : '<span>Indisponibil</span>'; }],
      ['Variante', function(p){ return esc(p.variants); }],
      ['Etichete', function(p){ return esc(p.tags || '—'); }]
    ];
    rows.forEach(function(row){
      html += '<tr><th>' + esc(row[0]) + '</th>' + list.map(function(p){ return '<td>' + row[1](p) + '</td>'; }).join('') + '</tr>';
    });
    html += '<tr class=\"compare-external-row\"><th>Alt site</th>' + list.map(function(p){
      var o = getExternalOffer(p.id);
      return '<td><div class=\"compare-external-box\">' +
        '<strong>Compară același produs</strong>' +
        '<label>Link produs de pe alt magazin</label><input type=\"url\" inputmode=\"url\" data-external-url=\"' + esc(p.id) + '\" value=\"' + esc(o.url) + '\" placeholder=\"https://magazin.ro/produs\" />' +
        '<div class=\"compare-external-result\" data-external-result=\"' + esc(p.id) + '\">' + (o.url ? '<a href=\"' + esc(o.url) + '\" target=\"_blank\" rel=\"noopener noreferrer\">' + esc(o.site || siteFromUrl(o.url)) + ' ↗</a>' : 'Introdu linkul. Carponiq încearcă automat să preia prețul.') + (o.price ? '<b>' + esc(o.price) + '</b>' : '') + '</div>' +
        '<button type=\"button\" class=\"compare-external-save\" data-save-external=\"' + esc(p.id) + '\">' + (o.url ? 'Actualizează oferta' : 'Verifică oferta') + '</button>' +
      '</div></td>';
    }).join('') + '</tr>';
    html += '</tbody></table>';
    table.innerHTML = html;
    wrap.appendChild(table);
  }
  function openFavorites() {
    var el = document.getElementById('favoritesOverlay');
    if (el) { el.hidden = false; document.body.classList.add('modal-open'); renderFavorites(); }
  }
  function closeFavorites() {
    var el = document.getElementById('favoritesOverlay');
    if (el) { el.hidden = true; document.body.classList.remove('modal-open'); }
  }
  function renderFavorites() {
    var wrap = document.querySelector('[data-favorites-content]');
    if (!wrap) return;
    var list = read(STORAGE_FAVORITES);
    if (!list.length) {
      wrap.innerHTML = '<div class="favorites-empty"><strong>Lista ta de favorite este goală.</strong><p>Apasă ♡ pe orice produs ca să îl păstrezi aici.</p></div>';
      return;
    }
    wrap.innerHTML = '<div class="favorites-grid">' + list.map(function(p){
      return '<article class="favorite-item">' +
        (p.image ? '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' : '') +
        '<div><span>' + esc(p.vendor) + '</span><a href="' + esc(p.url) + '"><strong>' + esc(p.title) + '</strong></a><b>' + esc(p.priceFormatted) + '</b>' +
        '<button type="button" data-remove-favorite="' + esc(p.id) + '">♥ Elimină</button></div></article>';
    }).join('') + '</div>';
  }

  document.addEventListener('click', function(event){
    var action = event.target.closest('[data-product-action]');
    if (action) {
      event.preventDefault();
      event.stopPropagation();
      var card = action.closest('[data-product-card]');
      if (!card) return;
      if (action.dataset.productAction === 'favorite') toggleFavorite(card);
      if (action.dataset.productAction === 'compare') toggleCompare(card);
      return;
    }
    if (event.target.closest('[data-open-compare]')) { event.preventDefault(); openCompare(); return; }
    if (event.target.closest('[data-open-favorites]')) { event.preventDefault(); openFavorites(); return; }
    if (event.target.closest('[data-close-compare]')) { closeCompare(); return; }
    if (event.target.closest('[data-close-favorites]')) { closeFavorites(); return; }
    var removeCompare = event.target.closest('[data-remove-compare]');
    if (removeCompare) {
      var compares = read(STORAGE_COMPARE).filter(function(p){ return String(p.id) !== String(removeCompare.dataset.removeCompare); });
      write(STORAGE_COMPARE, compares); syncButtons(); renderCompare(); return;
    }
    var saveExternal = event.target.closest('[data-save-external]');
    if (saveExternal) {
      var id = saveExternal.dataset.saveExternal;
      var urlInput = document.querySelector('[data-external-url=\"' + CSS.escape(String(id)) + '\"]');
      var url = cleanExternalUrl(urlInput && urlInput.value);
      if (urlInput && urlInput.value.trim() && !url) { notify('Introdu un link valid către magazin (http sau https).'); return; }
      if (!url) { saveExternalOffer(id, { id: id, url: '', price: '', site: '' }); renderCompare(); notify('Oferta externă a fost eliminată.'); return; }
      var result = document.querySelector('[data-external-result=\"' + CSS.escape(String(id)) + '\"]');
      if (result) result.innerHTML = '<span>Se verifică produsul...</span>';
      saveExternal.disabled = true;
      lookupExternalDetails(url).then(function(data){
        data=data||{}; data.id=id; data.url=url; data.site=data.site||siteFromUrl(url);
        saveExternalOffer(id, data);
        renderCompare();
        notify(data.price ? 'Oferta a fost actualizată: ' + data.price : 'Oferta a fost analizată.');
      }).catch(function(){
        saveExternalOffer(id, { id: id, url: url, price: '', site: siteFromUrl(url) });
        if (result) result.innerHTML = '<a href=\"' + esc(url) + '\" target=\"_blank\" rel=\"noopener noreferrer\">' + esc(siteFromUrl(url)) + ' ↗</a><span>Prețul nu a putut fi preluat automat de pe acest site.</span>';
        saveExternal.disabled = false;
        notify('Site-ul nu permite preluarea automată a prețului.');
      });
      return;
    }
    var externalUrlInput = event.target.closest('[data-external-url]');
    if (externalUrlInput && (event.type === 'change' || event.key === 'Enter')) {
      var extId = externalUrlInput.dataset.externalUrl;
      var extUrl = cleanExternalUrl(externalUrlInput.value);
      if (!extUrl) return;
      var extResult = document.querySelector('[data-external-result=\"' + CSS.escape(String(extId)) + '\"]');
      var extButton = document.querySelector('[data-save-external=\"' + CSS.escape(String(extId)) + '\"]');
      if (extResult) extResult.innerHTML = '<span>Se verifică prețul...</span>';
      if (extButton) extButton.disabled = true;
      lookupExternalPrice(extUrl).then(function(price){
        saveExternalOffer(extId, { id: extId, url: extUrl, price: price, site: siteFromUrl(extUrl) });
        if (extResult) extResult.innerHTML = '<a href=\"' + esc(extUrl) + '\" target=\"_blank\" rel=\"noopener noreferrer\">' + esc(siteFromUrl(extUrl)) + ' ↗</a><b>' + esc(price) + '</b>';
        if (extButton) extButton.disabled = false;
        notify('Preț preluat automat: ' + price);
      }).catch(function(){
        if (extResult) extResult.innerHTML = '<a href=\"' + esc(extUrl) + '\" target=\"_blank\" rel=\"noopener noreferrer\">' + esc(siteFromUrl(extUrl)) + ' ↗</a><span>Preț indisponibil automat.</span>';
        if (extButton) extButton.disabled = false;
      });
    }
    var removeFavorite = event.target.closest('[data-remove-favorite]');
    if (removeFavorite) {
      var favorites = read(STORAGE_FAVORITES).filter(function(p){ return String(p.id) !== String(removeFavorite.dataset.removeFavorite); });
      write(STORAGE_FAVORITES, favorites); syncButtons(); renderFavorites(); return;
    }
    if (event.target.classList.contains('compare-overlay') || event.target.classList.contains('favorites-overlay')) {
      event.target.hidden = true; document.body.classList.remove('modal-open');
    }
  });
  document.addEventListener('keydown', function(event){
    if (event.key !== 'Escape') return;
    closeCompare(); closeFavorites();
  });
  window.addEventListener('storage', function(){ syncButtons(); renderCompare(); renderFavorites(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ syncButtons(); renderCompare(); renderFavorites(); });
  else { syncButtons(); renderCompare(); renderFavorites(); }
})();
